import React from "react";
function Navbar() {
    return (
        <header className="">
            <h1 className="logo-image">DataHedge</h1>
            <nav className="nav">
                <ul className="nav-links">
                    <li className="nav-link"><a href="https://github.com/skabdulhaq" className="link-nav-a">Home</a></li>
                    <li className="nav-link"><a href="https://github.com/skabdulhaq" className="link-nav-a">About</a></li>
                    <li className="nav-link"><a href="https://github.com/skabdulhaq" className="link-nav-a">Contact Us</a></li>
                    <li className="nav-link"><a href="https://github.com/skabdulhaq" className="link-nav-a">Services</a></li>
                    <a href="https://github.com/skabdulhaq" className="login-btn"><button className="btn nav-btn">Login</button></a>
                    <a href="https://github.com/skabdulhaq" className="signup-btn"><button className="btn nav-btn">Sign Up</button></a>
                </ul>
            </nav>
            <button className="btn-mobile-nav" onClick={function () {
                const header = document.querySelector("header");
                header.classList.toggle("nav-open");
            }}>
                <ion-icon name="menu-outline" class="icon-mobile-nav"></ion-icon>
                <ion-icon name="close-outline" class="icon-mobile-nav"></ion-icon>
            </button>

        </header>
    );

}

export default Navbar;
